export const format = (value, lang='en-US', currency='USD') => {
	let formatter = new Intl.NumberFormat(lang, {style: 'currency', currency});
  return formatter.format(value);
};

export default {
  format,
};
